import styled from 'styled-components'

export const ReservedSpace = styled.span.attrs<{ $chars: number }>((x) => ({
  style: {
    minWidth: `${x.$chars}ch`,
  },
}))`
  display: inline-block;
  text-align: center;
`
